module.exports = __webpack_public_path__ + "img/no-billing.973dfef5.png";